export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_45-a1ba331114686a494b77e0edc075fcd9.jpg";